(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/radio.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/radio.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (components_radio)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }


  const Radio = props => {
    const name = props.name || 'radio[]';
    const id = props.id || "radio_".concat(name, "_").concat(props.value);
    const dataAttributes = {};
    const labelProps = _objectSpread(_objectSpread({}, props.labelProps), {}, {
      id,
      isButton: true
    });
    if (props.data) {
      props.data.forEach(data => {
        dataAttributes["data-".concat(data.key)] = data.value;
      });
    }
    const inputClasses = ['form-toggle-input', 'form-toggle-radio'];
    if (props.branding) {
      inputClasses.push("form-toggle-".concat(props.branding));
    } else {
      inputClasses.push('form-toggle-default');
    }
    if (props.classes) {
      inputClasses.push(props.classes);
    }
    if (props.className) {
      inputClasses.push(props.className);
    }
    return React.createElement("div", {
      className: "form-toggle ".concat(props.inline ? 'form-toggle-inline' : ''),
      style: props.minWidth && {
        minWidth: props.minWidth
      }
    }, React.createElement("input", _extends({
      checked: props.checked,
      className: inputClasses.join(' '),
      defaultChecked: props.defaultChecked,
      disabled: props.disabled,
      id: id,
      name: name,
      onChange: props.onChange,
      type: "radio",
      value: props.value
    }, dataAttributes)), React.createElement(external_svs_ui_ReactForm_namespaceObject.Label, labelProps, props.children));
  };
  Radio.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "Radio",
    "props": {
      "branding": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "checked": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "classes": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "data": {
        "description": "",
        "type": {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "key": {
                "name": "string",
                "required": false
              },
              "value": {
                "name": "string",
                "required": false
              }
            }
          }
        },
        "required": false
      },
      "defaultChecked": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "disabled": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "labelProps": {
        "description": "",
        "type": {
          "name": "shape",
          "value": {
            "alignRight": {
              "name": "bool",
              "required": false
            },
            "classes": {
              "name": "string",
              "required": false
            }
          }
        },
        "required": false
      },
      "minWidth": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "number"
          }, {
            "name": "string"
          }]
        },
        "required": false
      }
    }
  };
  const components_radio = Radio;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Radio = __webpack_exports__["default"];
})();

 })(window);